import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { AutoRow } from 'components/Layout/Row'
import { useTranslation } from 'contexts/Localization'
import { format } from 'date-fns'
import { Text } from 'vvs-uikit'

export interface DepositDetailProps {
  apr: string
  endDate: Date
  multiplier: number
  children?: ReactNode
}

export const BulletList = styled.ul`
  list-style-type: none;
  margin-top: 16px;
  padding: 0;
  max-width: 520px;
  background-color: ${({ theme }) => theme.colors.boostlightAquaBackground};
  padding: 18px;
  border-radius: 12px;
  color: ${({ theme }) => theme.colors.text};

  li {
    margin-left: 10px;
    display: flex;
  }

  li::before {
    content: '•';
    margin-right: 6px;
    margin-top: 2px;
    color: ${({ theme }) => theme.colors.textSubtle};
  }

  li::marker {
    font-size: 12px;
  }
`

const DepositDetail = ({ apr, endDate, multiplier, children }: DepositDetailProps) => {
  const { t } = useTranslation()

  return (
    <>
      <AutoRow justify="space-between" mt={3}>
        <Text color="textSubtle" small>
          {t('APR')}
        </Text>
        <Text small>{apr}%</Text>
      </AutoRow>
      <AutoRow justify="space-between" mt={1}>
        <Text color="textSubtle" small>
          {t('Multiplier')}
        </Text>
        <Text small>{multiplier / 100}x</Text>
      </AutoRow>
      <AutoRow justify="space-between" mt={1}>
        <Text color="textSubtle" small>
          {t('Lock End Date')}
        </Text>
        <Text small>{format(endDate, 'MMM dd, yyyy')}</Text>
      </AutoRow>
      {children}
      <BulletList>
        <li>
          <Text small color="textSubtle">
            {t('You will not be able to withdraw your tokens before the period end date.')}
          </Text>
        </li>
        <li>
          <Text small color="textSubtle">
            {t(
              'APR figures are estimates provided for your convenience only, and by no means represent guaranteed returns.',
            )}
          </Text>
        </li>
      </BulletList>
    </>
  )
}

export default DepositDetail
